



















import { Vue, Prop, Component, Watch } from 'vue-property-decorator'

@Component
export default class SelectButtonGroupComponent extends Vue {
  @Prop({ default: 'sample Button' }) public title!: string
  @Prop({ default: () => null }) public callback!: () => void
  @Prop({ default: []}) public members!: Array<{icon: string, title: string}>
  @Prop({ default: ''}) public value!: string
  @Prop({ default: false}) public disabled!: boolean

  private handleSelectButton(member: string) {
    this.$emit( 'input', this.value === member ? '' : member )
  }

}
